export default __webpack_public_path__ + "static/italie-ddf2468018ebf47684dc54efb1e209c7.webp";